let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cbzG9")).then(() => parcelRequire('aBaQE'));